import { IS_DICTIONARY_CHANGED_METHOD_FIELDS } from 'constants/MeshbotConstant';
import { convertDictionaryOperationToEventKind } from './convertDictionaryOperationToEventKind';
import { createBlockSelect } from '../createBlockSelect';
import { createOrUpdateGeofenceBlock } from './createOrUpdateGeofenceBlock';

/**
 * Builds UI-ready geofence trigger data based on a source block and controller metadata.
 *
 * This function:
 * - Extracts `user`, `location`, and `eventKind` from the trigger's `fields` array,
 * - Resolves the device name from items and devices,
 * - Converts the dictionary `operation` to a UI-level `eventKind`,
 * - Builds `triggersListBlock` (UI config) and `triggersSelectBlock` (editable trigger block).
 *
 * @param {Object} params - Parameters for UI geofence trigger.
 * @param {string} params.id - ID of the trigger.
 * @param {boolean} params.isNotBlock - Whether the trigger is wrapped with a NOT operator.
 * @param {Object} params.sourceData - Parsed `when` block or nested block.
 * @param {Array<Object>} params.items - Device items from controller.
 * @param {Array<Object>} params.devices - Devices from controller.
 * @returns {{
 *   triggersListBlock: { id: string, selectedFieldTrigger: string, not: boolean },
 *   triggersSelectBlock: Object
 * }} Prepared data for UI trigger editor and trigger block structure.
 *
 * @example
 * const data = buildUiGeofenceTriggerData({ id, isNotBlock, sourceData, items, devices });
 */
export const buildUiGeofenceTriggerData = ({ id, isNotBlock, sourceData, items, devices }) => {
    const uiGeofenceTrigger = sourceData?.fields.reduce((acc, { name, value }) => {
        if (name === IS_DICTIONARY_CHANGED_METHOD_FIELDS.ITEM) {
            const item = items.find(({ _id }) => _id === value);
            const device = devices.find(({ _id }) => _id === item?.deviceId);
            acc.user = device?.name;
        }

        if (name === IS_DICTIONARY_CHANGED_METHOD_FIELDS.KEY) {
            acc.location = value;
        }

        if (name === IS_DICTIONARY_CHANGED_METHOD_FIELDS.OPERATION) {
            acc.eventKind = convertDictionaryOperationToEventKind(value);
        }

        return acc;
    }, {});

    return {
        triggersListBlock: {
            id,
            selectedFieldTrigger: sourceData?.blockMeta?.nodeType,
            not: isNotBlock,
        },
        triggersSelectBlock: createBlockSelect(createOrUpdateGeofenceBlock(uiGeofenceTrigger)(), id, isNotBlock),
    };
};
